// Мягкий гейт показа виджета (T9): страница открывается с ?key=<WIDGET_KEY>.
// Ключ приходит из /api/config открыто — защита от случайных глаз и индексации,
// не безопасность (см. server/src/config.js).

// ?key=... из строки запроса; пусто/мусор → null
export function keyFromLocation(searchString) {
  try {
    const key = new URLSearchParams(searchString ?? "").get("key");
    return key?.trim() || null;
  } catch {
    return null;
  }
}

// hasStatus — в URL есть токен заказа: возврат с оплаты обязан работать без ключа
export function gateAllows({ widgetKey, key, hasStatus }) {
  if (!widgetKey) return true; // ключ не настроен — гейт выключен
  if (hasStatus) return true;
  return key === widgetKey;
}
